export default __webpack_public_path__ + "static/media/delv_bold2.a65c1730.svg";